import * as RAPIER from '@dimforge/rapier3d-compat'
import * as THREE from 'three'
import { Component } from '../../ecs/Component'
import { RigidBody } from './RigidBody'

class CollisionGroup {
    name: string
    id: number
    interactions: boolean[]
    constructor(name: string, id: number, interactions: boolean[]) {
        this.name = name
        this.id = id
        this.interactions = interactions
    }
}
export class Collider extends Component {
    //a table who associates collision groups with names
    static collisionGroupNames: Map<string, number>
    static collisionGroups: CollisionGroup[]
    static setupCollisionGroups() {
        if (Collider.collisionGroupNames === undefined) {
            Collider.collisionGroupNames = new Map<string, number>()
            Collider.collisionGroupNames.set('world', 0)
            Collider.collisionGroupNames.set('ghost', 1)
            Collider.collisionGroupNames.set('car', 2)

            Collider.collisionGroups = [new CollisionGroup('world', 0b0001, [true, false, true]), new CollisionGroup('ghost', 0b0010, [false, false, false]), new CollisionGroup('car', 0b0100, [true, false, false])]
        }
    }

    collision!: RAPIER.Collider
    wakeUpOnDestroy = true
    haveExternalRigidBody = true
    buildData: any
    desc!: RAPIER.ColliderDesc
    setup(data: any) {
        Collider.setupCollisionGroups()
        this.buildData = data
    }
    start(): void {
        const data = this.buildData
        let rigidBody = this.gameObject.getComponent(RigidBody)?.body
        this.desc = data.colliderDesc
        if (this.desc === undefined) {
            this.desc = RAPIER.ColliderDesc.cuboid(this.transform.scale.x / 2, this.transform.scale.y / 2, this.transform.scale.z / 2);
        }
        if (data.collisionGroup === undefined) {
            data.collisionGroup = 'world'
        }
        const collisionGroup = Collider.collisionGroups[Collider.collisionGroupNames.get(data.collisionGroup)!]
        let solverGroups = 0B0000
        for (let i = 0; i < Collider.collisionGroups.length; i++) {
            if (collisionGroup.interactions[i]) {
                solverGroups |= Collider.collisionGroups[i].id
            }
        }
        this.desc.setSolverGroups((collisionGroup.id << 16) | solverGroups)
        this.desc.setCollisionGroups((collisionGroup.id << 16) | solverGroups)


        if (rigidBody === undefined) {
            rigidBody = this.scene.physicsWorld.createRigidBody(RAPIER.RigidBodyDesc.fixed())
            rigidBody.setTranslation(this.transform.position, true)
            const rotation = new THREE.Quaternion().setFromEuler(this.transform.rotation)
            rigidBody.setRotation(new RAPIER.Quaternion(rotation.x, rotation.y, rotation.z, rotation.w), true)
            this.haveExternalRigidBody = false
            rigidBody.userData = { gameObject: this.gameObject, isColliderRb: true }
        }
        //this.syncronize(rigidBody)
        this.collision = this.scene.physicsWorld.createCollider(this.desc, rigidBody)

    }
    rebuild() {
        if (this.collision !== undefined) {
            if ((this.collision.parent()?.userData as any).isColliderRb) {
                //destroy fake rb
                this.scene.physicsWorld.removeRigidBody(this.collision.parent()!)

            }
            this.scene.physicsWorld.removeCollider(this.collision, this.wakeUpOnDestroy)
        }
        this.start()
    }
    syncronize(rb: RAPIER.RigidBody | undefined) {
        if (rb === undefined && this.collision !== undefined) {
            this.collision.setTranslation(this.transform.position.clone())
            const rotation = new THREE.Quaternion().setFromEuler(this.transform.rotation)
            this.collision.setRotation(new RAPIER.Quaternion(rotation.x, rotation.y, rotation.z, rotation.w))
        }
    }
    update(_dt: number): void {
    }
    render(_dt: number) {
        this.syncronize(this.gameObject.getComponent(RigidBody)?.body)
    }
    onDestroy(): void {
        this.scene.physicsWorld.removeCollider(this.collision, this.wakeUpOnDestroy)
    }
    onComponentAdded(_component: Component): void {

    }
}